import { FileSharer } from '@byteowls/capacitor-filesharer'

export async function downloadFile(filename: string, contentType: string, data: string) {
	if (isPlatform('capacitor')) {
		const bytes = new TextEncoder().encode(data)
		const base64 = btoa(String.fromCharCode(...bytes))
		await FileSharer.share({
			filename,
			contentType,
			base64Data: base64,
		})
	} else {
		const blob = new Blob([data], { type: contentType })
		const url = window.URL.createObjectURL(blob)
		const link = document.createElement('a')
		link.href = url
		link.download = filename
		document.body.appendChild(link)
		link.click()
		link.remove()

		window.URL.revokeObjectURL(url)
	}
}
